import { isEqual } from 'lodash';
import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomSearchableEntities from '../../../components/forms/CustomSearchableEntities';
import CustomSelect from '../../../components/forms/CustomSelect';
import DateField from '../../../components/forms/DateField';
import useClients from '../../../hooks/api-calls/useClients';
import { FilterOptions } from '../../../hooks/useFilters';
import { gender } from '../StudentForm';

interface StudentsFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const StudentsFilters: React.FC<StudentsFiltersProps> = ({ filters, updateFilters, resetFilters }) => {
    const { fetchClients, getClientsList } = useClients();
    return (
        <>
            <CustomSelect
                isSearchable
                id={'active'}
                label="Estado"
                options={[
                    { label: 'Todos', value: null },
                    { label: 'Activos', value: true },
                    { label: 'Desactivados', value: false }
                ]}
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ active: null });
                        return;
                    }
                    updateFilters({ active: e.value });
                }}
                value={filters.filter_filters?.active !== null
                    ? { label: filters.filter_filters?.active ? 'Activo' : 'Desactivado', value: filters.filter_filters?.active }
                    : { label: 'Todos', value: null }}
            />

            {/* Gender filter */}
            <CustomSelect
                isSearchable
                isClearable
                id={'gender'}
                label="Género"
                options={[
                    { label: 'Todos', value: null },
                    ...gender
                ]}
                onChange={(e: any) => {
                    updateFilters({ gender: e.value });
                }}
                value={filters.filter_filters?.gender !== null && filters.filter_filters?.gender !== undefined
                    ? { label: filters.filter_filters?.gender === 'male' ? 'Masculino' : 'Femenino', value: filters.filter_filters?.gender }
                    : { label: 'Todos', value: null }}
            />

            {/* Client filter */}
            <CustomSearchableEntities
                id="client"
                label="Cliente"
                filters={filters}
                updateFilters={updateFilters}
                fetchOptions={async (searchText: string | null) => {
                    return fetchClients({ search_text: searchText });
                }}
                permissions={[
                    {
                        group: 'contracts',
                        action: 'admin_contracts'
                    },
                    {
                        group: 'clients',
                        action: 'list_clients'
                    }
                ]}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "createdAt"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" },
                    { label: "Fecha de nacimiento", value: "birthDate" }
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </>
    );
};

export default StudentsFilters;